/**
 * Accounts tab — routes to set1 / set2 / set3 hub layouts via `accounts_variant`.
 */
import React from 'react';
import { useAccountsVariant } from '../data/domains/config';
import { AccountsScreenSet1 } from './variants/set1/AccountsScreenSet1';
import { AccountsScreenSet2 } from './variants/set2/AccountsScreenSet2';
import { AccountsScreenSet3 } from './variants/set3/AccountsScreenSet3';

export const AccountsScreen: React.FC = () => {
  const variant = useAccountsVariant();
  if (variant === 'set2') {
    return <AccountsScreenSet2 />;
  }
  if (variant === 'set3') {
    return <AccountsScreenSet3 />;
  }
  return <AccountsScreenSet1 />;
};

export default AccountsScreen;
